import EmailProviders from '@/ecm/variables/EmailProviders';
export default class Setting {
    constructor(dto) {
        this.emailAccount = '';
        this.emailPassword = '';
        this.emailServer = '';
        this.emailPort = '';
        this.emailUseSSL = false;
        this.sendGridApiKey = '';
        this.office365RefreshToken = '';
        this.provider = EmailProviders.SMTP;
        this.changedPassword = false;

        if (dto) {
            this.emailAccount = dto.EmailAccount;
            this.emailPassword = dto.EmailPassword;
            this.emailServer = dto.EmailServer;
            this.emailPort = dto.EmailPort;
            this.emailUseSSL = dto.EmailUseSSL;
            this.sendGridApiKey = dto.SendGridApiKey;
            this.office365RefreshToken = dto.Office365RefreshToken;
            this.provider = dto.Provider || EmailProviders.SMTP;
        }
    }

    toDto() {
        return {
            EmailAccount: this.emailAccount,
            EmailPassword: this.emailPassword,
            EmailServer: this.emailServer,
            EmailPort: this.emailPort,
            EmailUseSSL: this.emailUseSSL,
            SendGridApiKey: this.sendGridApiKey,
            Office365RefreshToken: this.office365RefreshToken ? this.office365RefreshToken : null,
            Provider: this.provider,
            ChangedPassword: this.changedPassword
        };
    }
}
